import { WorkflowGroupsQueryQuery } from '@/apollo/graphql';

type Group = NonNullable<
  NonNullable<
    WorkflowGroupsQueryQuery['workflowByRowId']
  >['groups']['nodes'][number]
>;

type GroupMembers = Group['members']['nodes'];

// from the group members query get the number of teams and participants
export const getGroupCounts = (groupMembers: GroupMembers) => {
  // build sets to get unique counts by rowId
  const teams = new Set();
  const users = new Set();
  const bots = new Set();

  groupMembers.forEach(groupMember => {
    const entity = groupMember?.account?.entity;
    if (!entity?.__typename) return;

    switch (entity.__typename) {
      case 'Account_User':
        // register the user
        users.add(entity.rowId);
        break;
      case 'Account_Bot':
        // register the bot
        bots.add(entity.rowId);
        break;
      case 'Account_Team': {
        // register the team
        teams.add(entity.rowId);
        // register its users and bots
        const {
          members: { nodes: teamUsers },
          bots: { nodes: teamBots }
        } = entity;
        teamUsers
          .filter(u => !!u)
          .forEach(user => {
            users.add(user.userId);
          });
        teamBots
          .filter(b => !!b)
          .forEach(bot => {
            bots.add(bot.rowId);
          });
        break;
      }
      case 'Account_Organization': {
        // register its teams, users and bots
        const {
          members: { nodes: orgaUsers },
          bots: { nodes: orgaBots },
          teams: { nodes: orgaTeams }
        } = entity;
        orgaTeams
          .filter(t => !!t)
          .forEach(team => {
            teams.add(team.rowId);
          });
        orgaUsers
          .filter(u => !!u)
          .forEach(user => {
            users.add(user.userId);
          });
        orgaBots
          .filter(b => !!b)
          .forEach(bot => {
            bots.add(bot.rowId);
          });
        break;
      }
      default:
        throw Error(`Unknown entity type ${entity.__typename}`);
    }
  });

  return {
    teams: teams.size,
    users: users.size,
    bots: bots.size
  };
};
